import { useState, useCallback } from "react";
import { validateConfirmationForm } from "../utils/validation";

export const useFormValidation = (formData) => {
  const [errors, setErrors] = useState({});

  const validateSubmit = useCallback(() => {
    const newErrors = validateConfirmationForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstKey = Object.keys(newErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus();
      }
      return false;
    }
    return true;
  }, [formData]);

  const clearError = useCallback((field) => {
    if (errors[field]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  }, [errors]);

  return {
    errors,
    setErrors,
    clearError,
    validateSubmit
  };
};
